import React from "react";
import { Tag } from "antd";
import styles from "./tag.module.scss";
import { KoText } from "../typography";
import KoIcon from '@kwapio/icons';
function KoTag(props) {
  const { value, bordered = false, custom=false, iconFront, iscount =true, radius, iconBack, count, color } = props;
  return (
    custom ? <div onClick={props.onClick && props.onClick} className={`${styles.wrapper} ${!radius ? styles.tagNoRadius : ''} ${styles[color]}`}>
      {iconFront && <KoIcon className={styles.icon} name={iconFront} width={14} height={14} />}
      <KoText ellipsis={true} text={value} className={styles.word} />
      {iconBack&& <KoIcon className={styles.icon} name={iconBack} width={14} height={14} />}
      {iscount && <KoText text={count} className={styles.count} />}
    </div> :
      <Tag style={{
        maxWidth: '265px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        display: 'inline-block',
        verticalAlign: 'middle'
      }} bordered={bordered} {...props}>{value}</Tag>
  );
}
export default KoTag;
